import axios from "axios";
import { useCallback } from "react";

import { GetAccessTokenFunc, IsAuthorizedFunc } from "@digital-services/shell";

import { headRequest } from "@/utils/api/swr-utils";

import { IS_AUTHORIZED_PATH } from "./paths";

export function useIsAuthorized(): IsAuthorizedFunc {
  const isAuthorizedFunction = useCallback(
    async (getAccessToken: GetAccessTokenFunc): Promise<boolean> => {
      try {
        await headRequest(IS_AUTHORIZED_PATH, getAccessToken);
        return true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          return false;
        }
        throw err;
      }
    },
    []
  );
  return isAuthorizedFunction;
}
